import { req } from '../../@api/request';

export default class mySearchOptionService {
  static list = async (type: string) => {
    const result = await req.get(`/loan/list/param?type=${type}`);
    return result.data;
  };

  static save = async (data: {
    type?: string;
    isCourtOrRegion?: string;
    court?: string;
    region?: string;
    search?: string;
    search2?: string;
    search3?: string;
    totalCategory?: string;
    minappraisedValue?: number;
    maxappraisedValue?: number;
    minBidPrice?: number;
    maxBidPrice?: number;
    minconstructArea?: number;
    maxconstructArea?: number;
    minlandArea?: number;
    maxlandArea?: number;
    minSaleDate?: string;
    maxSaleDate?: string;
    minApprovalDate?: string;
    maxApprovalDate?: string;
    bidno?: string;
    bidStatus?: string;
    specialItemCond?: string;
    specialItem?: string;
    zoning?: string;
    asset?: string;
    is_npl?: string;
    npl_holder?: string;
    sort?: string;
    limit?: number;
    offset?: number;
    title?: string;
    save_type?: string;
    search_type?: string;
  }) => {
    const queryString = Object.entries(data)
      .map(
        ([key, value]) =>
          `${encodeURIComponent(key)}=${encodeURIComponent(value ?? '')}`,
      )
      .join('&');
    const result = await req.post(`/loan/list/param/save2?${queryString}`, {
      save_type: data.save_type,
      search_type: data.search_type,
      title: data.title,
    });
    return result.data;
  };

  static delete = async (p_idx: number) => {
    const data = { p_idx: p_idx };
    const result = await req.patch(`/loan/list/param/delete`, data);
    return result.data;
  };
}
